import { HTTPClient, propsToDate } from "@abaco/web-common/src/HTTP";
import { ProtocolPrescription } from "../models/Prescription";

export default class ProtocolPrescriptionApi {
    private http: HTTPClient;
    private rootPath!: string;

    constructor(http: HTTPClient) {
        this.http = http;
        this.rootPath = "/sitiagri-rest-api/api_basic/v1"
    }

    public async getProtocolPrescriptions(protocol_id: number): Promise<ProtocolPrescription[]>{
        const res = await this.http.get(`${this.rootPath}/protocols/dictionary/${protocol_id}/prescriptions`)
        res.data.forEach((p: ProtocolPrescription) => propsToDate(p, ["start_date", "end_date"]));

        return res.data;
    }
}
